/// <reference types="web-bluetooth" />


import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BluetoothPrinterService } from 'src/app/services/bluetooth-api/bluetooh-printer.service';
import { ImpresionComponent } from '../impresion.component';
@Component({
  selector: 'app-impresion-arqueo',
  templateUrl: './impresion-arqueo.component.html',
  styleUrl: './impresion-arqueo.component.scss'
})
export class ImpresionArqueoComponent extends ImpresionComponent implements OnInit, OnChanges{

    @Input() arqueo: Record<string, any>;
    @Input() tipoImpresora: boolean ;
    @Output() eImprimir = new EventEmitter();
    
    printCharacteristic: BluetoothRemoteGATTCharacteristic ;

    constructor(
        public bluetoothPrinterService: BluetoothPrinterService,
        public messageService: MessageService,

    ) {
        super();
    }
        
    ngOnInit( ): void {
            
    }

    ngOnChanges(changes: SimpleChanges) {
        
    }

    async imprimir() {
        try {
            const imprimible = document.getElementById("print-cierre");
            
            if (imprimible) {
                const domClone = imprimible.cloneNode(true) as HTMLElement;
                let printSection = document.getElementById("printSection");
                
                if (!printSection) {
                    printSection = document.createElement("div");
                    printSection.id = "printSection";
                    document.body.appendChild(printSection);
                }
                
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
                
                // Perform the print operation
                window.print();
                
                // Cleanup: Remove the cloned content from printSection
                printSection.innerHTML = "";

                this.eImprimir.emit(true)
                
                // Optional: Hide the print preview or reset any related state
                // this.showPrint = false;
            }
        } catch (error) {
            console.error("Error occurred while printing:", error);
        }
    }

  
    async imprimirImpresoraTermica() {         
        try {
            const imprimible = document.getElementById('print-cierre');
            if (!imprimible) {
                console.error('Elemento imprimible no encontrado.');
                return;
            }
            
            const content = imprimible.innerText.trim().split('\n').filter(line => line.trim()!== '').join('\n');            
            if (!content) {
                console.error('Contenido imprimible vacío.');
                return;
            }
                        
            if (!this.bluetoothPrinterService.isPrinterConnected) {
                this.messageService.add({severity: 'info', summary: 'Impresora no conectada.', detail: 'Seleccione una impresora'});

                await this.bluetoothPrinterService.seleccionarImpresoraBluetooth();
                if ( this.bluetoothPrinterService.ConnectedDevice) {
                    this.printCharacteristic = this.bluetoothPrinterService.ConnectedDevice;
                }
            }else if ( this.bluetoothPrinterService.ConnectedDevice ){
                this.printCharacteristic =  this.bluetoothPrinterService.ConnectedDevice;
            }
            const encoder = new TextEncoder();
            const resetCommand = this.RESETEAR_IMPRESORA;
            await this.printCharacteristic.writeValue(resetCommand);
            const fontSizeCommand = this.FUENTE_PEQUENA; // Tamaño de fuente más pequeño
            await this.printCharacteristic.writeValue(fontSizeCommand);
            
            const encodedContent = encoder.encode(content);
            
            const chunkSize = 128;
            for (let i = 0; i < encodedContent.length; i += chunkSize) {
                const chunk = encodedContent.slice(i, i + chunkSize);
                await this.printCharacteristic.writeValue(chunk);
            }
            
            const cutCommand = this.CORTAR_PAPEL // Comando de corte de papel
            await this.printCharacteristic.writeValue(cutCommand);            
            const espacio = encoder.encode('\n\n\n')
            await this.printCharacteristic.writeValue(espacio);

            this.eImprimir.emit(true)

        } catch (error) {
            console.error('Error occurred while printing:', error);
        }
    }

    

}
